import { useTranslation } from 'react-i18next';

import { useViewerRoles } from '@treams/treams-hooks';
import { ArchiveIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button } from '@treams/treams-ui';

export default function DepartmentToolbar(props: { group: graphql.Group }) {
	const { t } = useTranslation();
	const { isHRBusinessPartner } = useViewerRoles();

	const [archive] = graphql.useArchiveGroupMutation();
	const [restore] = graphql.useRestoreGroupMutation();

	if (isHRBusinessPartner) return null;

	return props.group.isArchived ? (
		<Button
			ml={2}
			type="destructive"
			title={t('common.restore')}
			onClick={async () => {
				await restore({ variables: { input: { id: props.group.id } } });
			}}
		/>
	) : (
		<Button
			ml={2}
			type="destructive"
			icon={<ArchiveIcon />}
			title={t('common.archive')}
			disabled={!props.group.parent}
			onClick={async () => {
				await archive({ variables: { input: { id: props.group.id } } });
			}}
		/>
	);
}
